module.exports = "/assets/data/8e4b9b23ffc8b6de0f5f564788fe55dc-BT64.data.json";